// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* register.css */

.register-container {
  display: flex;
  flex-direction: column;
  background-color: #00081a;
  height: 96.5vh; /* viewport units can remain */
  border-radius: 1.875em; /* 3em converted from 30px */
  justify-content: space-around; /* Changed to space-around for better spacing */
  align-items: center;
  padding: 1.25em; /* 20px converted to em */
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
}




.logintext {
  color: white;
}

.loginimage {
  max-width: 15em;
}

.register-container h2 {
  color: white;
  margin-bottom: 1.875em; /* 30px converted to em */
  font-size: 1.75em;
  /* font-size: 1.5em;  xx-large is generally 24px */
}

.register-container form {
  display: flex;
  flex-direction: column;
  height: 75%; /* percentage values can remain */
  width: 80%; /* percentage values can remain */
  gap: 1.25em; /* 20px converted to em */
  align-items: center; /* Center-align the form items */
}

.register-container form div {
  width: 100%; /* Full width within the form */
  display: flex;
  flex-direction: column;
  align-items: flex-start; /* Align the labels and inputs to the start */
}

.register-container form label {
  margin-bottom: 0.3125em; /* 5px converted to em */
  color: #007aff; /* Make label color same as button color */
  font-weight: 600; /* Make labels slightly bold */
}

.register-container form input {
  padding: 0.625em; /* 10px converted to em */
  width: 100%; /* Full width within the div */
  border: 0.0625em solid #ccc; /* 1px converted to em */
  border-radius: 0.625em; /* 10px converted to em */
  font-size: 1em; /* Assuming base is 16px */
  background: #fff; /* Add a white background for better visibility */
}

.register-container form button {
  background-color: #007aff;
  color: white;
  padding: 0.9375em; /* 15px converted to em */
  padding-left: 2.8125em; /* 45px converted to em */
  padding-right: 2.8125em; /* 45px converted to em */
  border: none;
  font-weight: 800;
  border-radius: 0.625em; /* 10px converted to em */
  font-size: 1em; /* Assuming base is 16px */
  cursor: pointer;
  transition: background-color 0.3s; /* Smooth transition for hover effect */
}

.register-container form button:hover {
  background-color: #005ecb;
}



/* Media query for small screens like the iPhone SE */
@media (max-width: 375px) {
  .register-container {
    padding: 0.75em; /* Decreased padding */
    height: auto; /* Let the height be dynamic */
    min-height: 96vh; /* Ensure it's at least as tall as the viewport */
  }

  .loginimage {
    max-width: 5em;
  }

  .register-container form label {
    font-size: 0.85em; 
    
  }

  .register-container h2 {
    margin-bottom: 1em; /* Smaller bottom margin */
    font-size: 1.25em; /* Slightly smaller font size */
  }

  .register-container form {
    width: 90%; /* Increase width to utilize more space */
   
    gap: .75em; /* 20px converted to em */
    align-items: center; /* Center-align the form items */
  }

  .register-container form input,
  .register-container form button {
    padding: 0.5em; /* Smaller padding */
  }

  .register-container form button {
    padding-left: 1.5em; /* Reduced padding on the sides for the button */
    padding-right: 1.5em; /* Reduced padding on the sides for the button */
  }
}

/* what my iphone thinks this app is sized */
@media (max-width: 896px) {
  .register-container {
    padding: 0.75em; /* Decreased padding */
    height: auto; /* Let the height be dynamic */
    min-height: 96.5vh;
    max-height: 97vh; /* Ensure it's at least as tall as the viewport */
  }

  .dock {
    display: none;
  }

  .loginimage {
    max-width: 5em;
  }

  .register-container form label {
    font-size: 0.85em; 
    
  }

  .register-container h2 {
    margin-bottom: 1em; /* Smaller bottom margin */
    font-size: 1.75em; /* Slightly smaller font size */
  }

  .register-container form {
    width: 90%; /* Increase width to utilize more space */
   
    gap: .75em; /* 20px converted to em */
    align-items: center; /* Center-align the form items */
  }

  .register-container form input,
  .register-container form button {
    padding: 0.5em; /* Smaller padding */
  }

  .register-container form button {
    padding-left: 1.5em; /* Reduced padding on the sides for the button */
    padding-right: 1.5em; /* Reduced padding on the sides for the button */
  }
}

/* Additional media query for medium-sized screens if necessary, e.g., tablets */
@media (max-width: 768px) {
  /* Adjust styles as needed for medium-sized screens */
  .register-container {
    padding: 1em; /* Adjusted padding for medium screens */
    border-radius: 1em; /* Smaller border-radius */
  }


  .dock {
    display: none;
  }
  /* ... and so on for other elements ... */
}

/* You might need more media queries to handle other screen sizes and orientations */

`, "",{"version":3,"sources":["webpack://./src/components/css/Register.css"],"names":[],"mappings":"AAAA,iBAAiB;;AAEjB;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,cAAc,EAAE,8BAA8B;EAC9C,sBAAsB,EAAE,4BAA4B;EACpD,6BAA6B,EAAE,+CAA+C;EAC9E,mBAAmB;EACnB,eAAe,EAAE,yBAAyB;EAC1C,uGAAuG;AACzG;;;;;AAKA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,sBAAsB,EAAE,yBAAyB;EACjD,iBAAiB;EACjB,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW,EAAE,iCAAiC;EAC9C,UAAU,EAAE,iCAAiC;EAC7C,WAAW,EAAE,yBAAyB;EACtC,mBAAmB,EAAE,gCAAgC;AACvD;;AAEA;EACE,WAAW,EAAE,+BAA+B;EAC5C,aAAa;EACb,sBAAsB;EACtB,uBAAuB,EAAE,6CAA6C;AACxE;;AAEA;EACE,uBAAuB,EAAE,wBAAwB;EACjD,cAAc,EAAE,0CAA0C;EAC1D,gBAAgB,EAAE,8BAA8B;AAClD;;AAEA;EACE,gBAAgB,EAAE,yBAAyB;EAC3C,WAAW,EAAE,8BAA8B;EAC3C,2BAA2B,EAAE,wBAAwB;EACrD,sBAAsB,EAAE,yBAAyB;EACjD,cAAc,EAAE,0BAA0B;EAC1C,gBAAgB,EAAE,iDAAiD;AACrE;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB,EAAE,yBAAyB;EAC5C,sBAAsB,EAAE,yBAAyB;EACjD,uBAAuB,EAAE,yBAAyB;EAClD,YAAY;EACZ,gBAAgB;EAChB,sBAAsB,EAAE,yBAAyB;EACjD,cAAc,EAAE,0BAA0B;EAC1C,eAAe;EACf,iCAAiC,EAAE,uCAAuC;AAC5E;;AAEA;EACE,yBAAyB;AAC3B;;;;AAIA,qDAAqD;AACrD;EACE;IACE,eAAe,EAAE,sBAAsB;IACvC,YAAY,EAAE,8BAA8B;IAC5C,gBAAgB,EAAE,iDAAiD;EACrE;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;;EAEnB;;EAEA;IACE,kBAAkB,EAAE,0BAA0B;IAC9C,iBAAiB,EAAE,+BAA+B;EACpD;;EAEA;IACE,UAAU,EAAE,yCAAyC;;IAErD,UAAU,EAAE,yBAAyB;IACrC,mBAAmB,EAAE,gCAAgC;EACvD;;EAEA;;IAEE,cAAc,EAAE,oBAAoB;EACtC;;EAEA;IACE,mBAAmB,EAAE,gDAAgD;IACrE,oBAAoB,EAAE,gDAAgD;EACxE;AACF;;AAEA,4CAA4C;AAC5C;EACE;IACE,eAAe,EAAE,sBAAsB;IACvC,YAAY,EAAE,8BAA8B;IAC5C,kBAAkB;IAClB,gBAAgB,EAAE,iDAAiD;EACrE;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;;EAEnB;;EAEA;IACE,kBAAkB,EAAE,0BAA0B;IAC9C,iBAAiB,EAAE,+BAA+B;EACpD;;EAEA;IACE,UAAU,EAAE,yCAAyC;;IAErD,UAAU,EAAE,yBAAyB;IACrC,mBAAmB,EAAE,gCAAgC;EACvD;;EAEA;;IAEE,cAAc,EAAE,oBAAoB;EACtC;;EAEA;IACE,mBAAmB,EAAE,gDAAgD;IACrE,oBAAoB,EAAE,gDAAgD;EACxE;AACF;;AAEA,gFAAgF;AAChF;EACE,qDAAqD;EACrD;IACE,YAAY,EAAE,wCAAwC;IACtD,kBAAkB,EAAE,0BAA0B;EAChD;;;EAGA;IACE,aAAa;EACf;EACA,yCAAyC;AAC3C;;AAEA,oFAAoF","sourcesContent":["/* register.css */\n\n.register-container {\n  display: flex;\n  flex-direction: column;\n  background-color: #00081a;\n  height: 96.5vh; /* viewport units can remain */\n  border-radius: 1.875em; /* 3em converted from 30px */\n  justify-content: space-around; /* Changed to space-around for better spacing */\n  align-items: center;\n  padding: 1.25em; /* 20px converted to em */\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif;\n}\n\n\n\n\n.logintext {\n  color: white;\n}\n\n.loginimage {\n  max-width: 15em;\n}\n\n.register-container h2 {\n  color: white;\n  margin-bottom: 1.875em; /* 30px converted to em */\n  font-size: 1.75em;\n  /* font-size: 1.5em;  xx-large is generally 24px */\n}\n\n.register-container form {\n  display: flex;\n  flex-direction: column;\n  height: 75%; /* percentage values can remain */\n  width: 80%; /* percentage values can remain */\n  gap: 1.25em; /* 20px converted to em */\n  align-items: center; /* Center-align the form items */\n}\n\n.register-container form div {\n  width: 100%; /* Full width within the form */\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start; /* Align the labels and inputs to the start */\n}\n\n.register-container form label {\n  margin-bottom: 0.3125em; /* 5px converted to em */\n  color: #007aff; /* Make label color same as button color */\n  font-weight: 600; /* Make labels slightly bold */\n}\n\n.register-container form input {\n  padding: 0.625em; /* 10px converted to em */\n  width: 100%; /* Full width within the div */\n  border: 0.0625em solid #ccc; /* 1px converted to em */\n  border-radius: 0.625em; /* 10px converted to em */\n  font-size: 1em; /* Assuming base is 16px */\n  background: #fff; /* Add a white background for better visibility */\n}\n\n.register-container form button {\n  background-color: #007aff;\n  color: white;\n  padding: 0.9375em; /* 15px converted to em */\n  padding-left: 2.8125em; /* 45px converted to em */\n  padding-right: 2.8125em; /* 45px converted to em */\n  border: none;\n  font-weight: 800;\n  border-radius: 0.625em; /* 10px converted to em */\n  font-size: 1em; /* Assuming base is 16px */\n  cursor: pointer;\n  transition: background-color 0.3s; /* Smooth transition for hover effect */\n}\n\n.register-container form button:hover {\n  background-color: #005ecb;\n}\n\n\n\n/* Media query for small screens like the iPhone SE */\n@media (max-width: 375px) {\n  .register-container {\n    padding: 0.75em; /* Decreased padding */\n    height: auto; /* Let the height be dynamic */\n    min-height: 96vh; /* Ensure it's at least as tall as the viewport */\n  }\n\n  .loginimage {\n    max-width: 5em;\n  }\n\n  .register-container form label {\n    font-size: 0.85em; \n    \n  }\n\n  .register-container h2 {\n    margin-bottom: 1em; /* Smaller bottom margin */\n    font-size: 1.25em; /* Slightly smaller font size */\n  }\n\n  .register-container form {\n    width: 90%; /* Increase width to utilize more space */\n   \n    gap: .75em; /* 20px converted to em */\n    align-items: center; /* Center-align the form items */\n  }\n\n  .register-container form input,\n  .register-container form button {\n    padding: 0.5em; /* Smaller padding */\n  }\n\n  .register-container form button {\n    padding-left: 1.5em; /* Reduced padding on the sides for the button */\n    padding-right: 1.5em; /* Reduced padding on the sides for the button */\n  }\n}\n\n/* what my iphone thinks this app is sized */\n@media (max-width: 896px) {\n  .register-container {\n    padding: 0.75em; /* Decreased padding */\n    height: auto; /* Let the height be dynamic */\n    min-height: 96.5vh;\n    max-height: 97vh; /* Ensure it's at least as tall as the viewport */\n  }\n\n  .dock {\n    display: none;\n  }\n\n  .loginimage {\n    max-width: 5em;\n  }\n\n  .register-container form label {\n    font-size: 0.85em; \n    \n  }\n\n  .register-container h2 {\n    margin-bottom: 1em; /* Smaller bottom margin */\n    font-size: 1.75em; /* Slightly smaller font size */\n  }\n\n  .register-container form {\n    width: 90%; /* Increase width to utilize more space */\n   \n    gap: .75em; /* 20px converted to em */\n    align-items: center; /* Center-align the form items */\n  }\n\n  .register-container form input,\n  .register-container form button {\n    padding: 0.5em; /* Smaller padding */\n  }\n\n  .register-container form button {\n    padding-left: 1.5em; /* Reduced padding on the sides for the button */\n    padding-right: 1.5em; /* Reduced padding on the sides for the button */\n  }\n}\n\n/* Additional media query for medium-sized screens if necessary, e.g., tablets */\n@media (max-width: 768px) {\n  /* Adjust styles as needed for medium-sized screens */\n  .register-container {\n    padding: 1em; /* Adjusted padding for medium screens */\n    border-radius: 1em; /* Smaller border-radius */\n  }\n\n\n  .dock {\n    display: none;\n  }\n  /* ... and so on for other elements ... */\n}\n\n/* You might need more media queries to handle other screen sizes and orientations */\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
